<template>
  <el-dialog class="report"
             :visible.sync="reportVisible"
             :close-on-click-modal="false"
             @closed="closeDialog"
             width="80%"
             @open="openCb"
             title="考勤报告"
             :loading="loading">
    <div class="reportSearchCont">
      <el-form :model="searchForm"
               ref="searchForm"
               label-width
               :inline="true">
        <el-form-item label="员工姓名">
          <el-input placeholder="请输入员工姓名"
                    maxlength="10"
                    size="small"
                    v-model="searchForm.name"
                    style="width:160px;"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status"
                     size="small"
                     placeholder="请选择状态"
                     style="width:160px;">
            <el-option v-for="item in statusList"
                       :key="item.status"
                       :label="item.name"
                       :value="item.status"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select v-model="searchForm.check_status"
                     style="width:160px;"
                     size="small"
                     placeholder="请选择状态">
            <el-option v-for="item in checkStatusList"
                       :key="item.check_status"
                       :label="item.name"
                       :value="item.check_status"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所在部门">
          <selectbutton :props="props"
                        :options="optionData"
                        :value="searchForm.depart_id"
                        :clearable="isClearable"
                        :accordion="isAccordion"
                        @getValue="getValue($event)"
                        height="200"
                        ref="selectBtn"></selectbutton>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     @click="getReport">
            查询
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-folder-add"
                     size="small"
                     @click="allExport">
            批量导出报告
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="reportTable">
      <el-table border
                :data="tableData"
                ref="tableData"
                v-loading="loading"
                highlight-current-row
                height='400'
                @sort-change="sortChange">
        <el-table-column label="姓名"
                         align="center"
                         property="name">
        </el-table-column>
        <el-table-column label="工号"
                         property="job_no"
                         align="center"
                         width="120">
        </el-table-column>
        <el-table-column label="部门"
                         property="depart"
                         align="center"
                         width="100">
        </el-table-column>
        <el-table-column label="年月"
                         align="center">
          <template slot-scope="scope">
            {{scope.row.year}}-{{scope.row.month}}
          </template>
        </el-table-column>
        <el-table-column label="应出勤天数"
                         property="need_work_days"
                         align="center"
                         width="100">
        </el-table-column>
        <el-table-column label="实出勤天数"
                         property="real_work_days"
                         align="center"
                         width="100">
        </el-table-column>
        <el-table-column label="缺勤天数"
                         property="miss_work_days"
                         align="center">
        </el-table-column>
        <el-table-column label="迟到次数"
                         align="center">
          <template slot-scope="scope">
            <el-tooltip class="item"
                        effect="dark"
                        :content='`迟到分钟：${scope.row.late_minute}分钟`'
                        placement="top">
              <div>{{scope.row.late_count}}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="早退次数"
                         align="center">
          <template slot-scope="scope">
            <el-tooltip class="item"
                        effect="dark"
                        :content='`早退分钟：${scope.row.early_minute}分钟`'
                        placement="top">
              <div>{{scope.row.early_count}}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="加班次数"
                         property="over_hour"
                         align="center"
                         sortable='custom'
                         width="120"
                         :default-sort="{prop: 'over_hour', order: null}">
          <template slot-scope="scope">
            <el-tooltip class="item"
                        effect="dark"
                        :content='`加班小时：${scope.row.over_hour}小时`'
                        placement="top">
              <div>{{scope.row.over_count}}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="工作时长"
                         property="work_hour"
                         align="center"
                         sortable='custom'
                         width="120"
                         :default-sort="{prop: 'work_hour', order: null}">
        </el-table-column>
        <el-table-column label="状态"
                         property="status_cn"
                         align="center">
          <template slot-scope="scope">
            <div :class="scope.row.status==2?'redText':''">
              {{scope.row.status_cn}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="审核状态"
                         property="check_status"
                         align="center">
          <template slot-scope="scope">
            <div :class="scope.row.check_status=='未审核'?'redText':''">
              {{scope.row.check_status?scope.row.check_status:'--'}}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="审核人"
                         property="checker"
                         align="center">
          <template slot-scope="scope">
            {{scope.row.checker?scope.row.checker:'--'}}
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         align="center"
                         width="80">
          <template slot-scope="scope">
            <div class="color-blue">
              <el-button type="text"
                         size="small"
                         class="color-blue"
                         @click="detail(scope.row)">详情</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <span slot="footer"
          class="dialog-footer">
      <pagination :total="total"
                  :page.sync="page"
                  :perPage.sync="perPage"></pagination>
    </span>
    <reportDetail :detailItem.sync="detailItem"
                  :reportDetailVisible.sync='reportDetailVisible'
                  ref="childreportDetail"></reportDetail>
  </el-dialog>
</template>
<script>
import pagination from "@/comon/components/pagination"
import reportDetail from "./reportDetail"
import selectbutton from "../../../../comon/components/selectbutton"
import * as oaApi from "@/http/oaApi.js";
import * as api from "@/http/api.js";
export default {
  data () {
    return {
      loading: false,
      page: 1,
      perPage: 10,
      total: '',
      statusList: [
        { name: '请选择', status: '' },
        { name: '正常', status: 1 },
        { name: '异常', status: 2 }
      ],
      checkStatusList: [
        { name: '请选择', check_status: '' },
        { name: '未审核', check_status: 1 }
      ],
      tableData: [],
      searchForm: {
        name: '',
        status: '',
        check_status: '',
        depart_id: ''
      },
      orderby_workhour: null,
      orderby_overcount: null,

      detailItem: '',
      reportDetailVisible: false,

      isClearable: false, // 可清空（可选）
      isAccordion: true, // 可收起（可选）
      valueId: '', // 初始ID（可选）
      props: {
        // 配置项（必选）
        value: "id",
        label: "name",
        children: "child",
        // disabled: true
      },
      // 选项列表（必选）
      list: [],
    }
  },
  methods: {
    closeDialog () {
      this.tableItem = ''
      this.searchForm = {
        name: '',
        status: '',
        check_status: ''
      }
      this.$refs.selectBtn.clearHandle()
      this.page = 1
      this.perPage = 10
      this.$emit('update:reportVisible', false)
    },
    /**
     * 获取报告列表
     */
    getReport () {
      oaApi.attendanceReport({
        year: this.tableItem.year,
        month: this.tableItem.month,
        name: this.searchForm.name,
        status: this.searchForm.status,
        check_status: this.searchForm.check_status,
        'per-page': this.perPage,
        depart_id: this.searchForm.depart_id,
        page: this.page,
        orderby_workhour: this.orderby_workhour,
        orderby_overcount: this.orderby_overcount
      }, 'get').then(res => {
        if (res) {
          this.tableData = res.data
          this.total = res.total
          this.$refs.tableData.bodyWrapper.scrollTop = 0;
        }
      })
    },
    /**
     * 点击个人详情
     */
    detail (row) {
      this.detailItem = row
      this.reportDetailVisible = true
    },
    /**
     * 批量导出报告
     */
    allExport () {
      oaApi.attendanceReportExport({
        year: this.tableItem.year,
        month: this.tableItem.month,
        name: this.searchForm.name,
        status: this.searchForm.status,
        depart_id: this.searchForm.depart_id
      }, 'get').then(res => {
        if (res) {
          window.open(res.data.url)
        }
      })
    },
    // 取值
    getValue (value) {
      this.searchForm.depart_id = value.id
    },
    /**
     *  获取组织架构信息
     */
    depart () {
      api.depart({}, 'get').then(res => {
        if (res) {
          this.list = res.data
        }
      })
    },
    sortChange (column) {
      this.orderby_workhour = ''
      this.orderby_overcount = ''
      if (column.order == 'descending') {
        if (column.prop == 'work_hour') {
          this.orderby_workhour = 'desc'
        } else if (column.prop == 'over_hour') {
          this.orderby_overcount = 'desc'
        }
      } else if (column.order == 'ascending') {
        if (column.prop == 'work_hour') {
          this.orderby_workhour = 'asc'
        } else if (column.prop == 'over_hour') {
          this.orderby_overcount = 'asc'
        }
      } else if (column.order == null) {
        if (column.prop == 'work_hour') {
          this.orderby_workhour = ''
        } else if (column.prop == 'over_hour') {
          this.orderby_overcount = ''
        }
      }
      this.getReport()
    },
  },
  computed: {
    /* 转树形数据 */
    optionData () {
      let cloneData = JSON.parse(JSON.stringify(this.list)); // 对源数据深度克隆
      return cloneData.filter(father => {
        // 循环所有项，并添加children属性
        let branchArr = cloneData.filter(child => father.id == child.parent_id); // 返回每一项的子级数组
        branchArr.length > 0 ? (father.child = branchArr) : ""; //给父级添加一个children属性，并赋值
        return father.parent_id == 0; //返回第一层
      });
    },
    mixed () {
      const { tableItem, reportVisible } = this
      return {
        tableItem, reportVisible
      }
    }
  },
  watch: {
    mixed: {
      handler (newValue) {
        this.tableItem = newValue.tableItem
        if (newValue.reportVisible) {
          this.getReport()
          this.depart()
        }
      },
      deep: true,
      immediate: false
    },
    perPage: {
      handler (newValue) {
        this.perPage = newValue;
        this.getReport()
      },
      deep: true,
      immediate: false
    },
    page: {
      handler (newValue) {
        this.page = newValue;
        this.getReport()
      },
      deep: true,
      immediate: false
    }
  },
  props: {
    reportVisible: 'Boolean',
    tableItem: 'Object',
  },
  components: {
    pagination: pagination,
    reportDetail: reportDetail,
    selectbutton: selectbutton
  }
}
</script>
<style lang="scss">
.report {
    .el-dialog {
        display: flex;
        flex-direction: column;
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        /*height:600px;*/
        max-height: calc(100% - 30px);
        max-width: calc(100% - 30px);
    }
    .el-dialog .el-dialog__body {
        flex: 1;
        overflow: auto;
    }
    .el-dialog__body {
        padding: 0 20px;
    }
    .reportSearchCont {
        .el-form {
            flex-wrap: wrap;
            display: inline-flex;
            justify-content: flex-start;
            width: 100%;
            box-sizing: border-box;
            align-items: center;
        }
    }
    .reportTable {
        height: 100%;
        .redText {
            color: red;
        }
    }
}
</style>